export const TOP_N_MIN = 1;
export const TOP_N_MAX = 100;
export const TOP_N_DEFAULT = 10;

export const clampTopN = (value: number): number => {
  if (Number.isNaN(value)) return TOP_N_DEFAULT;
  return Math.min(TOP_N_MAX, Math.max(TOP_N_MIN, Math.trunc(value)));
};

export const parseTopN = (raw: string | undefined): number => {
  if (!raw) return TOP_N_DEFAULT;
  return clampTopN(Number(raw));
};
